// Ported from v2 MMM-React/src/util/numbers.js
// V7 (D1): English UI + en number formatting — numbro's built-in default locale is
// en-US (dot-decimal, v2's rendering), so no language pack registration is needed.
import numbro from 'numbro'

export function formatCompactNumber(n: number): string {
  const abs = n < 0 ? -n : n
  return abs > 1000
    ? numbro(n).format({ spaceSeparated: true, average: true, mantissa: 2 })
    : numbro(n).format({ average: false, mantissa: 2 })
}

/** Wave-3 §3: axis ticks only ("400k", "1.5m") — no space, trimmed mantissa. The
 *  Σ/ø stat cells and bar value labels deliberately keep formatCompactNumber. */
export function formatAxisTick(n: number): string {
  const abs = n < 0 ? -n : n
  return abs > 1000
    ? numbro(n).format({ average: true, mantissa: 2, trimMantissa: true, spaceSeparated: false })
    : numbro(n).format({ average: false, mantissa: 2, trimMantissa: true })
}

/** ONE formatter for every Δ-growth chip (row 9 defect: raw interpolation). */
export function formatGrowthPercent(n: number): string {
  return numbro(n).format({ mantissa: 2, trimMantissa: true })
}

export function toMaxDecimals(n: number): number {
  return +parseFloat(String(n)).toFixed(2)
}

export function getDifferenceInPercent(prev: number, curr: number): number {
  if (prev === 0) return 0
  return toMaxDecimals((curr / prev - 1) * 100)
}

/** Wave-4 §2: DataValue's split of formatCompactNumber output. Splits on the
 *  spaceSeparated averaging suffix (k/m/b/t) so the unit can render dimmed; the
 *  round-trip `number + ' ' + unit === formatCompactNumber(n)` is contract-tested —
 *  the two must never drift. */
export function splitCompactNumber(n: number): { number: string; unit: string | null } {
  const formatted = formatCompactNumber(n)
  const m = /^(.*) ([kmbt])$/.exec(formatted)
  return m ? { number: m[1]!, unit: m[2]! } : { number: formatted, unit: null }
}
